//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TeacherSection',
  components: {
    ElSlider: () => import('@/components/common/Slider'),
    TeacherPhotoStyled: () => import('@/components/common/TeacherPhotoStyled'),
  },
  data() {
    return {
      options: {
        slidesPerView: 3,
        spacing: 40,
        loop: false,
        duration: 1000,
        slideChanged: (s) => {
          this.current = s.details().relativeSlide
        },
        breakpoints: {
          '(max-width: 1280px)': {
            slidesPerView: 2,
            loop: true,
          },
          '(max-width: 640px)': {
            slidesPerView: 1,
            loop: true,
            dragStart: () => {
              this.setPause(true)
            },
            dragEnd: () => {
              this.setPause(false)
            },
          },
        },
      },
      current: 1,
      sliderSize: 0,
      pause: false,
      interval: null,
      hideArrow: false,
      noAvatarPhoto: '',
    }
  },
  computed: {
    teachers() {
      return this.$getTeachers() || []
    },
  },
  mounted() {
    window.addEventListener('resize', this.resize, true)
    this.resize()
  },
  beforeDestroy() {
    if (this.$refs.slider) {
      this.$refs.slider.slider.destroy()
      this.resetInterval()
    }
  },
  methods: {
    teacherName(fullName, firstName) {
      if (firstName !== undefined && firstName.length > 0) {
        return firstName
      }

      return fullName.split(' ')[1]
    },
    resize() {
      if (this.$refs.slider) {
        this.hideArrow =
          this.$refs.slider.slider.details().size >
          this.$refs.slider.slider.details().slidesPerView
        if (window.innerWidth < 640) {
          this.sliderSize = this.$refs.slider.slider.details().size
          this.options.slideChanged = (s) => {
            this.current = s.details().relativeSlide
          }
          this.$refs.slider.slider.refresh(this.options)
          this.setInterval()
        } else {
          this.resetInterval()
        }
      }
    },
    setPause(active) {
      this.pause = active
      this.setInterval()
    },
    resetInterval() {
      clearInterval(this.interval)
    },
    setInterval() {
      if (this.$refs.slider) {
        this.resetInterval()
        this.interval = setInterval(() => {
          if (!this.pause) {
            this.$refs.slider.slider.next()
          }
        }, 3000)
      }
    },
    teacherPhoto(url) {
      if (url) {
        return url
      }

      return require('@/assets/img/redesign/common/teacher-photo.png')
    },
    getDirection() {
      return this.$direction()
    },
  },
}
